// Module
var code = "<label class=\"switch\" ng-class=\"{&#39;switch--checked&#39;: isChecked(), &#39;switch--disabled&#39;: disabled}\"><input ng-change=\"onChange()\" ng-disabled=\"disabled\" ng-model=\"ngModel\" type=\"checkbox\" /><div class=\"switch__path\"></div><span class=\"switch__toggle\"></span></label>\n";
// Exports
module.exports = code;